import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

export const MentionsLegalesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="sticky top-0 z-50 bg-[#09090b]/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-zinc-400 hover:text-white transition">
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo-youmi.png" alt="YOUMI GREEN VTC" className="w-10 h-10" />
            <span className="text-lg font-bold text-white font-['Outfit']">YOUMI <span className="text-emerald-500">GREEN</span></span>
          </button>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white font-['Outfit'] mb-8" data-testid="mentions-legales-title">Mentions Légales</h1>
        
        <div className="space-y-8 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Éditeur du site</h2>
            <p>
              Le site <strong className="text-white">youmigreenvtc.com</strong> est édité par <strong className="text-white">YOUMI GREEN VTC</strong>, 
              Société par Actions Simplifiée Unipersonnelle (SASU), SIREN 889 633 020, SIRET 889 633 020 00017, 
              siège social : 1 rue du Bel Air, 91000 Évry-Courcouronnes.
            </p>
            <p className="mt-2">Président : <strong className="text-white">MELLOUK Youssef</strong></p>
            <p>Email : <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline">contact@youmigreenvtc.com</a></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Directeur de la publication</h2>
            <p>M. MELLOUK Youssef, Président de la SASU YOUMI GREEN VTC.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Hébergement</h2>
            <p>Le site est hébergé par <strong className="text-white">Emergent</strong> (app.emergent.sh).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Activité réglementée</h2>
            <p>
              YOUMI GREEN VTC exerce une activité de Voiture de Tourisme avec Chauffeur (VTC), réglementée par la 
              loi n° 2014-1104 du 1er octobre 2014. Le chauffeur est titulaire d'une carte professionnelle VTC 
              délivrée par l'autorité préfectorale compétente.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus du site (textes, images, logos, graphismes) est la propriété exclusive de 
              YOUMI GREEN VTC. Toute reproduction, représentation ou diffusion, totale ou partielle, sans 
              autorisation écrite préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">Droit applicable</h2>
            <p>
              Les présentes mentions sont soumises au droit français. En cas de litige, les tribunaux français 
              sont seuls compétents.
            </p>
          </section>

          <p className="text-zinc-500 text-sm pt-4 border-t border-zinc-800">Dernière mise à jour : 15 mars 2026</p>
        </div>

        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/cgv" className="text-emerald-400 hover:underline">CGV</Link>
          <Link to="/confidentialite" className="text-emerald-400 hover:underline">Politique de confidentialité</Link>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
